var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"task__header--desktop",style:(_vm.style)},[_c('td',{staticClass:"text-bold",attrs:{"colspan":"6"}},[_vm._v(" "+_vm._s(_vm.task.project.company.name)+" ")]),_c('td',{staticClass:"task__status"})])}
var staticRenderFns = []

export { render, staticRenderFns }